import { FeatureToggleClientService } from 'feature-toggle-client/dist/FeatureToggleClientService';
export class LaunchDarklyProcessor {
    static process({ message, source, trackingProperties }) {
        const allFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        const messageResponse = {
            response: allFlags[message.content.parameters.flag],
            trackingProperties,
        };
        switch (message.content.method) {
            case 'getLaunchDarklyVar':
                source.postMessage(messageResponse, '*');
                break;
            default:
                throw new Error('Unrecognized LaunchDarkly method: method');
        }
    }
}
